import React from 'react';
import {useTranslation} from 'react-i18next';

import ControlButton from 'components/Interview/OnlineInterview/RightPanel/Participants/Controls/ControlButton';
import SoundIcon from 'components/common/icons/onlineInterview/SoundIcon';
import DisabledSoundIcon from 'components/common/icons/onlineInterview/DisabledSoundIcon';

import styles from './Controls.module.scss';

function ParticipantControls({isSoundEnabled, isStreamingAudio, changeSoundEnabled}) {
    const {t} = useTranslation();

    return (
        isStreamingAudio && (
            <div className={styles.controls}>
                <ControlButton
                    changeValue={changeSoundEnabled}
                    value={isSoundEnabled}
                    enabledIcon={SoundIcon}
                    disabledIcon={DisabledSoundIcon}
                    enableText={t('onlineInterview:tooltips.enableAudio')}
                    disableText={t('onlineInterview:tooltips.disableAudio')}
                    tooltipPosition='left'
                    tooltipClassName={styles.rightTooltip}
                />
            </div>
        )
    );
}

export default React.memo(ParticipantControls);
